import {
  create as apiCreate
} from 'api/project'

export const create = (projectName, type, billingAccountId, currency, timezone) => async dispatch => {
  return dispatch(apiCreate(projectName, type, billingAccountId, currency, timezone))
}
